import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { SystemService, ToolService } from '../../../camtl.service';
import { RouteValidationService } from "../../../../../shared/route-validation.service";

@Component({
  selector: 'copy-tools-dialog',
  templateUrl: './copy-tools-dialog.component.html',
  //styleUrls: ['./copy-tools-dialog.component.scss']
})
export class CopyToolsDialogComponent implements OnInit {

  constructor(private systemService: SystemService,
    private toolService: ToolService,
    private routeValidationService: RouteValidationService) { }

  @Input() newSystem: any;
  @Input() showWindow: boolean;
  private selectedSystemId: any;
  private systems: any;
  private tools: any;
  private selectedTools: any[];

  @Output() save: EventEmitter<any> = new EventEmitter();
  @Output() cancel: EventEmitter<any> = new EventEmitter();

  ngOnInit() {
    var self = this;
    if (this.newSystem && this.routeValidationService.isActiveRoute('MESC/CAMTL/MasterToolList/List') && self.showWindow) {
      this.systemService.read("/numbers?$filter=Status eq Active", true);
    }

  }

  ngOnChanges() {
    var self = this;
    if (this.newSystem && this.routeValidationService.isActiveRoute('MESC/CAMTL/MasterToolList/List') && self.showWindow) {
      this.systemService.read("/numbers?$filter=Status eq Active", true);
    }
  }

  onSystemChange(e) {
    var self = this;
    this.selectedSystemId = e;

    if (this.selectedSystemId && this.routeValidationService.isActiveRoute('MESC/CAMTL/MasterToolList/List')) {
      this.toolService.read("/system/" + this.selectedSystemId, true).then(function (response) {
        self.tools = response;
        if (response.length > 0 && response[0].ToolDetail.ToolNumber) {
          for (var i = 0; i < self.tools.length; i++) {
            self.tools[i]["DisplayNumber"] = self.tools[i].ToolDetail.ToolNumber;
          }
        }
      })
    }

  }

  onToolChange(e) {
    this.selectedTools = [];
    for (var i = 0; i < this.tools.length; i++) {
      if (e.includes(this.tools[i].Id)) {
        this.selectedTools.push(this.tools[i]);
      }
    }
  }

  onSave(e) {
    e.preventDefault();
    this.save.emit(this.selectedTools);
  }

  onCancel(e) {
    e.preventDefault();
    this.onClose();
  }

  onClose() {
    this.showWindow = false;
    this.cancel.emit();
  }

}
